"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.quote = void 0;
const quote_1 = require("../quote");
const w_call = (context, print) => {
    context.popQuote().call(context, print);
};
const w_compose = (context) => {
    const right = context.popQuote();
    const left = context.popQuote();
    context.pushQuote(new quote_1.BuiltinQuote((context, output) => {
        left.call(context, output);
        right.call(context, output);
    }));
};
const w_curry = (context) => {
    const quote = context.popQuote();
    const arg = context.pop();
    context.pushQuote(new quote_1.BuiltinQuote((context, output) => {
        context.push(arg);
        quote.call(context, output);
    }));
};
const w_negate = (context) => {
    const quote = context.popQuote();
    context.pushQuote(new quote_1.BuiltinQuote((context, output) => {
        quote.call(context, output);
        context.pushBoolean(!context.popBoolean());
    }));
};
const w_dip = (context, print) => {
    const quote = context.popQuote();
    const value = context.pop();
    quote.call(context, print);
    context.push(value);
};
exports.quote = [
    ["quote:call", w_call],
    ["quote:compose", w_compose],
    ["quote:curry", w_curry],
    ["quote:negate", w_negate],
    ["quote:dip", w_dip],
];
